/* Marquee (sections/cs-marquee.liquid)
   Repeats the items until they cover the screen, then scrolls the row by
   exactly one copy of the items so the loop is seamless. The duration comes
   from the copy's width and the speed setting (pixels per second). */

if (!customElements.get('cs-marquee')) {
  customElements.define(
    'cs-marquee',
    class CsMarquee extends HTMLElement {
      connectedCallback() {
        this.track = this.querySelector('.cs-marquee__track');
        this.group = this.querySelector('.cs-marquee__group');
        if (!this.track || !this.group) return;

        if (this.hasAttribute('data-start-when-visible')) {
          this.classList.add('is-waiting');
          this.visibilityObserver = new IntersectionObserver(
            (entries) => {
              if (entries.some((entry) => entry.isIntersecting)) {
                this.classList.remove('is-waiting');
                this.visibilityObserver.disconnect();
              }
            },
            { threshold: 0.1 }
          );
          this.visibilityObserver.observe(this);
        }

        this.resizeObserver = new ResizeObserver(() => this.layout());
        this.resizeObserver.observe(this);
        this.layout();
      }

      disconnectedCallback() {
        this.resizeObserver?.disconnect();
        this.visibilityObserver?.disconnect();
      }

      layout() {
        const groupWidth = this.group.getBoundingClientRect().width;
        if (!groupWidth) return;

        // Enough copies to cover the visible width plus one copy to scroll into
        const copiesNeeded = Math.ceil(this.clientWidth / groupWidth) + 1;
        const copies = this.track.querySelectorAll('.cs-marquee__group');

        for (let i = copies.length; i < copiesNeeded; i++) {
          const copy = this.group.cloneNode(true);
          copy.setAttribute('aria-hidden', 'true');
          copy.querySelectorAll('[data-shopify-editor-block]').forEach((el) => el.removeAttribute('data-shopify-editor-block'));
          this.track.appendChild(copy);
        }

        const speed = Math.max(parseFloat(this.dataset.speed) || 50, 1);
        this.style.setProperty('--cs-marquee-distance', `${groupWidth}px`);
        this.style.setProperty('--cs-marquee-duration', `${groupWidth / speed}s`);
        this.classList.add('is-ready');
      }
    }
  );
}
